// Mobile filters
$("#filtersMobile-button").on("click", function() {
    // Fade in/out background before animation
    $("#filtersMobile-background").fadeToggle(300);
    
    // Animate button
    $(this).find("svg").toggleClass("rotate-180");
    
    // Animate content
    $("#filtersMobile-content").slideToggle(300);
});

$(".filters-mobile").on("change", function() {
    const selected_collections = [];
    let all_checkboxes = $(".filters-mobile");

    all_checkboxes.each(function() {
        if ($(this).is(":checked")) {
            selected_collections.push($(this).data("collection-handle"));
        }
    })

    if (selected_collections.length > 0) {
        let first_collection = true;
        for (let i = 0; i < selected_collections.length; i++) {
            $.ajax({
                method: "GET",
                url: "/collections/" + selected_collections[i] + "?view=ajax",
                dateType: "html",
                success: function(response) {
                    if (first_collection) {
                        $("#products-grid").html(response);
                        first_collection = false;
                    } else {
                        $("#products-grid").append(response);
                    }
                }
            });
        }

        // $(selected_collections).each(function() {
        //     $.ajax({
        //         method: "GET",
        //         url: "/collections/" + $(this) + "?view=ajax",
        //         dataType: "html",
        //         success: function(response) {
        //             if (first_collection) {
        //                 $("#products-grid").html(response);
        //                 first_collection = false;
        //             } else {
        //                 $("#products-grid").append(response);
        //             }
        //         }
        //     })
        // })
    } else {
        $.ajax({
            method: "GET",
            url: "/collections/all?view=ajax",
            dataType: "html",
            success: function(response) {
                $("#products-grid").html(response);
            }
        })
    }

});


// Desktop filters
$(".filters-desktop").on("click", function() {
    $.ajax({
        method: "GET",
        url: "/collections/" + $(this).data("collection-handle") + "?view=ajax",
        dateType: "html",
        success: function(response) {
            $("#products-grid").html(response);
        }
    })
});


// Image hover effect
$(".collection-product").on({
    mouseenter: function() {
        $(this).find(".featured-image").stop().fadeTo(300, 0);
        $(this).find(".secondary-image").stop().fadeTo(300, 1);
    },
    mouseleave: function() {
        $(this).find(".secondary-image").stop().fadeTo(300, 0);
        $(this).find(".featured-image").stop().fadeTo(300, 1);
    }
})